import React, { useEffect, useState } from "react";
import AppRoutes from "../routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import AlertWrapper from "../components/AlertWrapper";
import { Domain_URL } from "../constants/states";
import Loader from "../components/Loader";
import { getPatientNotification } from "../actions/dashboardAction";
import { checkIfAuthorized, logout } from "../actions/authAction";
import { useLocation } from "react-router-dom";
import { getUserDetail, isColorLight } from "../utils/helper";
import { DATE_FORMAT_APPLIED } from "../constants/types/settingsType";
function App() {
  const messages = useSelector((state) => state.alert.messages);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const alerts = messages.map((x) => (
    <AlertWrapper
      key={x.id}
      message={x.message}
      variant={x.variant}
      id={x.id}
    />
  ));

  useEffect(async () => {
    async function fetchData() {
      let response = await fetch(
        Domain_URL + "api/manageForms?action=getThemeSettings"
      );
      let json = await response.json();
      document.documentElement.style.setProperty(
        "--orange",
        json.fields[0].value
      );
      if (isColorLight(json.fields[0].value)) {
        document.documentElement.style.setProperty("--header-color", "#3b3d3e");
      } else {
        document.documentElement.style.setProperty("--header-color", "#e1e1e1");
      }
      localStorage.setItem("theme", json.fields[0].value);

      let dateResponse = await fetch(
        Domain_URL + "api/manageForms?action=getDateSettings"
      );
      let dateJson = await dateResponse.json();
      localStorage.setItem("dateFormat", dateJson.fields[0].value);
    }

    if (!localStorage.getItem("theme")) {
      fetchData();
    } else {
      document.documentElement.style.setProperty(
        "--orange",
        localStorage.getItem("theme")
      );
      dispatch({
        type: DATE_FORMAT_APPLIED,
        payload: localStorage.getItem("dateFormat"),
      });
      if (isColorLight(localStorage.getItem("theme"))) {
        document.documentElement.style.setProperty("--header-color", "#3b3d3e");
      } else {
        document.documentElement.style.setProperty("--header-color", "#e1e1e1");
      }
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== "/login" && getUserDetail()) {
      let expirationDate = new Date(getUserDetail()?.tokenExpiryDate); // Assuming the input is in UTC
      let currentDate = new Date();
      if (expirationDate < currentDate) {
        dispatch(logout());
      }
    }
  }, []);

  return (
    <>
      <div className="powered-by">
        <div
          onClick={() => {
            window.open("https://myherbalpharmacy.com/");
          }}
        >
          <p>Powered by</p>
          <img src="https://api.myherbalpharmacy.com/images/logo.png" />
        </div>
      </div>
      <AppRoutes />
      <div className="alert-box">{alerts}</div>
    </>
  );
}

export default App;
